import React, { useState } from "react";
import { Navigate, Outlet, Link, useLocation } from "react-router-dom";
import Modal from "../../components/generics/Modal";
import {
  isLoggedIn,
  isServiceProvider,
  getServiceProviderData,
  logout,
} from "../../utils/AuthService";
import { withRouter } from "utils/WithRouter";

const ProviderLayout = ({ history }) => {
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const location = useLocation();
  const providerData = getServiceProviderData();

  // If not logged in, redirect to login
  if (!isLoggedIn()) {
    return <Navigate to="/login" />;
  }

  // If logged in but NOT a service provider, redirect to main app
  if (!isServiceProvider()) {
    return <Navigate to="/orders" />;
  }

  const handleLogout = () => {
    logout();
    history.push("/login");
  };

  const isActive = (path, exact = false) => {
    if (exact) {
      return location.pathname === path;
    }
    return location.pathname === path || location.pathname.startsWith(path + "/");
  };

  return (
    <div className="app">
      <header className="app-header navbar">
        <Link className="navbar-brand" to="/provider-portal" style={{ backgroundImage: "none", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <span style={{ color: "#fff", fontSize: "14px", fontWeight: "500" }}>Service Portal</span>
        </Link>
        <ul className="nav navbar-nav hidden-md-down">
          <li className="nav-item px-3">
            <Link
              to="/provider-portal"
              className={`nav-link ${isActive("/provider-portal", true) ? "active" : ""}`}
            >
              <i className="fa fa-dashboard me-1"></i> Dashboard
            </Link>
          </li>
          <li className="nav-item px-3">
            <Link
              to="/provider-portal/tasks"
              className={`nav-link ${isActive("/provider-portal/tasks") ? "active" : ""}`}
            >
              <i className="fa fa-tasks me-1"></i> My Tasks
            </Link>
          </li>
        </ul>
        <ul className="nav navbar-nav ml-auto">
          <li className="nav-item px-3 hidden-md-down">
            <span className="nav-link" style={{ cursor: "default" }}>
              <i className="fa fa-building me-1"></i>
              {providerData?.name || "Service Provider"}
            </span>
          </li>
          <li className="nav-item dropdown resp-pr-15">
            <a
              className="nav-link resp-logout"
              href="#"
              role="button"
              onClick={(e) => { e.preventDefault(); setShowLogoutModal(true); }}
            >
              <i className="fa fa-sign-out"></i> <span className="hidden-xxs-down">Logout</span>
            </a>
          </li>
        </ul>
      </header>
      <div className="app-body">
        <div className="sidebar" style={{ width: "220px" }}>
          <nav className="sidebar-nav">
            <ul className="nav">
              <li className="nav-item">
                <Link
                  to="/provider-portal"
                  className={`nav-link ${isActive("/provider-portal", true) ? "active" : ""}`}
                >
                  <i className="fa fa-dashboard"></i> Dashboard
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/provider-portal/tasks"
                  className={`nav-link ${isActive("/provider-portal/tasks") ? "active" : ""}`}
                >
                  <i className="fa fa-tasks"></i> My Tasks
                </Link>
              </li>
              <li className="nav-title" style={{ padding: "0.75rem 1rem", color: "#73818f", fontSize: "80%", fontWeight: "700", textTransform: "uppercase" }}>
                Quick Filters
              </li>
              <li className="nav-item">
                <Link
                  to="/provider-portal/tasks?status=PENDING"
                  className="nav-link"
                >
                  <i className="fa fa-clock-o"></i> Pending
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/provider-portal/tasks?status=IN_PROGRESS"
                  className="nav-link"
                >
                  <i className="fa fa-spinner"></i> In Progress
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/provider-portal/tasks?status=OVERDUE"
                  className="nav-link"
                >
                  <i className="fa fa-exclamation-triangle"></i> Overdue
                </Link>
              </li>
            </ul>
          </nav>
        </div>
        <main className="main">
          <div className="container-fluid mt-2">
            <Outlet />
          </div>
        </main>
      </div>
      <footer className="app-footer">
        <a href="http://www.grazianosgroup.com/">Grazianos</a> &copy; 2025 - Service Provider Portal
      </footer>
      <Modal
        closeModal={() => setShowLogoutModal(false)}
        isModalOpen={showLogoutModal}
        onConfirm={handleLogout}
        onCancel={() => setShowLogoutModal(false)}
        header="LOG OUT"
        content="Are you sure you want to log out?"
        onConfirmButtonText="Yes"
        onCancelButtonText="No"
      />
    </div>
  );
};

export default withRouter(ProviderLayout);
